import { styled } from 'styled-components';
import { Media } from '@/js/libs/ui/src/theme/Media';
export const Wrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  white-space: nowrap;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${Media.smMin} {
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};

    & > :nth-child(1) {
      order: 1;
    }

    & > :nth-child(2) {
      order: 2;
    }

    & > :nth-child(3) {
      order: 3;
    }

    & > :nth-child(4) {
      order: 4;
    }
  }

  @media ${Media.xsMax} {
    border-radius: 8px;
    padding: 8px 12px;
    margin-top: 8px;
    justify-content: space-between;

    & > :nth-child(1) {
      order: 2;
    }

    & > :nth-child(2) {
      order: 1;
    }

    & > :nth-child(3) {
      order: 3;
    }
  }
`;
export const PageInfoWrapper = styled.div `
  @media ${Media.smMin} {
    margin-left: auto;
  }
`;
